import "../styles/loader.css";
import React from "react";

export const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader-1"></div>
    </div>
  );
};
